import Script from 'next/script';
import React from 'react';


const GTM_KEY = process.env.NEXT_PUBLIC_GTM_KEY;

const initializeGTMEvents = () => {
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
};

const GTMInjector = () => {
  return (
    <Script
      async
      strategy="afterInteractive"
      onLoad={initializeGTMEvents}
      //src={`${publicRuntimeConfig?.publicHost}/m/gtm.js?id=${GTM_KEY}`} TO BE CHANGED WHEN APPROVED
      src={`https://www.googletagmanager.com/gtm.js?id=${GTM_KEY}`}
    />
  );
};

export default function GTM() {
  if (GTM_KEY) {
    return <GTMInjector />;
  }

  return null;
}
